import { render, staticRenderFns } from "./group_billing.vue?vue&type=template&id=72b468a0&scoped=true"
import script from "./group_billing.vue?vue&type=script&lang=ts"
export * from "./group_billing.vue?vue&type=script&lang=ts"
import style0 from "./group_billing.vue?vue&type=style&index=0&id=72b468a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b468a0",
  null
  
)

export default component.exports